import { StackStatus } from "../../../services/backend_gateway/__generated__/backend_gateway-types";
import { RestApiComponent } from "./component";

export const RestApiContainer = (props: {
  deploymentId: string;
  navigateToHelp: (stepId: string) => void;
  restApiStackStatus: StackStatus | null;
}) => {
  const { deploymentId, restApiStackStatus } = props;

  return (
    <RestApiComponent
      loading={false}
      deploymentId={deploymentId}
      restApiStackParamsJson={restApiStackStatus?.parametersJSON || null}
      restApiStackStatus={restApiStackStatus?.status || null}
    />
  );
};
